/**
 * botFlashRetreat — Flash D toward fountain while kiting out of AA (FID-BOT-23).
 *
 * Pure JS — no Three.js, no DOM.
 */

import { canCastSlot } from './botCast.js';

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

function hasFlashOnD(bot) {
  const d = String(bot?.spellD || bot?.spell1 || 'flash').toLowerCase();
  return d === 'flash';
}

function enemyChampionInRange(bot, enemies, range) {
  if (!(range > 0)) return false;
  for (const enemy of enemies) {
    if (!enemy || enemy.isDead || enemy.team === bot.team) continue;
    if (enemy.type !== 'champion') continue;
    const dist = Math.hypot(enemy.x - bot.x, entityZ(enemy) - entityZ(bot));
    if (dist <= range) return true;
  }
  return false;
}

export function botFlashRetreatDecision(bot, enemies, fountain, attackRange) {
  if (!bot || !fountain) return null;
  if (!hasFlashOnD(bot) || !canCastSlot(bot, 'D')) return null;
  if (!enemyChampionInRange(bot, enemies, attackRange)) return null;
  return {
    action: 'cast',
    slot: 'D',
    targetX: fountain.x,
    targetZ: fountain.z !== undefined ? fountain.z : fountain.y
  };
}
